import { FocusEventHandler, useState } from "react";


export const PasswordInput = (props: Props) => {

    const [showPassword, setShowPassword] = useState<boolean>(false);

    return (
        <div className='rel'>
            <input id="regPassword" name="password" aria-label='password'
                type={showPassword ? 'text' : 'password'}
                className={`text-field ${props.getClassNames('password')}`}
                value={props.password}
                onChange={(e) => props.onChange(e)}
                onBlur={props.onBlur}
            />
            <span className={'eye-icon ' + (showPassword ? 'show' : 'hide')} onClick={() => setShowPassword(!showPassword)} />
        </div>
    )
}

type Props = {
    password: string,
    getClassNames: Function,
    onChange: Function,
    onBlur: FocusEventHandler
}